import { getCookie } from "./getCookie";

const updateCookie = (name, value) => {
    const existingCookie = document.cookie
        .split("; ")
        .find((c) => c.startsWith(name));

    if (!existingCookie) {
        return;
    }

    // Preserve other attributes (e.g., path, domain, expiration)
    const attributes = existingCookie.split(";").slice(1).join("; ");
    document.cookie = `${name}=${value};path=/;  ${attributes}`;
};

// remove cookie when logout
const deleteCookie = (name, shop_id) => {
    const currentCookie = getCookie(name);

    if (currentCookie) {
        try {
            if(!shop_id){
                updateCookie(name, "");
                return
            }
            const currentCookieObj = JSON.parse(currentCookie);
            delete currentCookieObj[shop_id];
            updateCookie(name, JSON.stringify(currentCookieObj));
        } catch (e) {
            console.error("Error parsing cookie JSON:", e);
        }
    } else {
        console.warn("No cookie found for:", name);
        return false;
    }
};

export default deleteCookie;
